import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return (strategicAxis) =>
    present(
      repository
        .removeStrategicAxis(strategicAxis)
        .then((removedStrategicAxis) => removedStrategicAxis)
        .catch(() => Promise.reject(strategicAxis)),
    );
}

export type { Interactor };

export { createInteractor };
